import { findErrorCode } from '@/lib/shareImport/findErrorCode';

const ERROR_KEYS = {
  FRAMEIO_PRO_REQUIRED: 'frameio.errors.proRequired',
  FRAMEIO_UNSUPPORTED_LINK: 'frameio.errors.unsupportedLink',
  FRAMEIO_PRIVATE_OR_EXPIRED: 'frameio.errors.privateOrExpired',
  FRAMEIO_NOT_FOUND: 'frameio.errors.notFound',
  FRAMEIO_NO_VIDEOS: 'frameio.errors.noVideos',
  FRAMEIO_NOT_READY: 'frameio.errors.notReady',
  FRAMEIO_API_CHANGED: 'frameio.errors.unavailable',
  FRAMEIO_UNAVAILABLE: 'frameio.errors.unavailable',
  FRAMEIO_DOWNLOAD_FAILED: 'frameio.errors.downloadFailed',
} as const;

export type FrameioErrorCode = keyof typeof ERROR_KEYS;

// Inspect only known Apollo error containers; never expose provider messages.
export function getFrameioErrorCode(value: unknown): FrameioErrorCode | null {
  return findErrorCode(value, ERROR_KEYS);
}

export function getFrameioErrorKey(error: unknown): string {
  return ERROR_KEYS[getFrameioErrorCode(error) ?? 'FRAMEIO_UNAVAILABLE'];
}
